import { useTranslation } from 'next-i18next';
import React from 'react';
import { StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import MbwDownloadItem from './MBWDownloadItem';

const MbwStageDownloads = ({ uiComponent }: { uiComponent: StageComponentInterface }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full">
      <span className="pt-4 pl-6 pr-4 mb-8 text-xl font-bold">{uiComponent.downloadsTitle}</span>
      {uiComponent.downloads &&
        [...uiComponent.downloads]
          .sort((a, b) => a.sortIndex - b.sortIndex)
          ?.map((d) => <MbwDownloadItem download={d} iconColor={uiComponent?.styling?.textColor} />)}
    </div>
  );
};

export default MbwStageDownloads;
